export class SortText
{
  static byLength<T>( array:T[], getText?:( t:T ) => string, useCache:boolean = true )
  { 
    getText = getText || ( ( t:T ) => { return t + ""; } );
    
    let cache = new Map<T,string>();

    let getTextOnce = ( t:T )=>
    {
      if ( cache.has( t ) )
      {
        return cache.get( t );
      }

      cache.set( t, getText( t ) );

      return cache.get( t );
    }

    let getTextInSort = useCache ? getTextOnce : getText;

    array.sort(
      ( a:T, b:T ) => 
      {
        let textA = getTextInSort( a );
        let textB = getTextInSort( b );

        return textA.length - textB.length;
      }
    );
  }

  static sort<T>( array:T[], getText?:( t:T ) => string, useCache:boolean = true )
  {
    getText = getText || ( ( t:T ) => { return t + ""; } );

    let cache = new Map<T,string>();

    let getTextOnce = ( t:T )=>
    {
      if ( cache.has( t ) )
      {
        return cache.get( t );
      }

      cache.set( t, getText( t ) );

      return cache.get( t );
    }

    let getTextInSort = useCache ? getTextOnce : getText;


    array.sort(
      ( a:T, b:T ) => 
      {
        if ( a === null && b === null )
        {
          return 0;
        }

        if ( a === null || b === null )
        {
          return a === null ? 1 : -1;
        }

        let textA = getTextInSort( a );
        let textB = getTextInSort( b );

        if ( textA == null && textB === null )
        {
          return 0;
        }

        
        if ( textA === null || textB === null )
        {
          return textA === null ? 1 : -1;
        }

        if ( textA === textB )
        {
          return 0;
        }

        if ( textA.length < textB.length )
        {
          if ( textB.startsWith( textA ) )
          {
            return -1;
          }
        }
        else if ( textB.length < textA.length )
        {
          if ( textA.startsWith( textB ) )
          {
            return 1;
          }
        }

        if ( textA < textB )
        {
          return -1;
        }

        if ( textA > textB )
        {
          return 1;
        }

        return 0;
      }
    )
  }
}